import {
  useEntryLoader,
  useEventLoader,
  useGetEntries,
  useGetEvents,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { createPaginatedLoadingContextProvider } from "./createPaginatedLoadingContextProvider"
import {
  CollectionKey,
  UserLocalStorageKey,
} from "src/types"

export const [
  EventLoadingProvider,
  useEventLoadingDetails,
  useEventLoading,
  useEventReloading,
] = createPaginatedLoadingContextProvider({
  localStorageKey: UserLocalStorageKey.EventsLoadedRanges,
  collectionKey: CollectionKey.UserEvent,
  useLoader: useEventLoader,
  useGetItems: useGetEvents,
})

export const [
  EntryLoadingProvider,
  useEntryLoadingDetails,
  useEntryLoading,
  useEntryReloading,
] = createPaginatedLoadingContextProvider({
  localStorageKey: UserLocalStorageKey.EntriesLoadedRanges,
  collectionKey: CollectionKey.UserEntry,
  useLoader: useEntryLoader,
  useGetItems: useGetEntries,
})
